var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7076 20.7073C26.6147 20.8003 26.5044 20.874 26.383 20.9244C26.2616 20.9747 26.1315 21.0006 26.0001 21.0006C25.8687 21.0006 25.7385 20.9747 25.6171 20.9244C25.4957 20.874 25.3854 20.8003 25.2926 20.7073L16.0001 11.4136L6.70757 20.7073C6.51993 20.895 6.26543 21.0004 6.00007 21.0004C5.7347 21.0004 5.48021 20.895 5.29257 20.7073C5.10493 20.5197 4.99951 20.2652 4.99951 19.9998C4.99951 19.7344 5.10493 19.4799 5.29257 19.2923L15.2926 9.29231C15.3854 9.19933 15.4957 9.12557 15.6171 9.07525C15.7385 9.02493 15.8687 8.99902 16.0001 8.99902C16.1315 8.99902 16.2616 9.02493 16.383 9.07525C16.5044 9.12557 16.6147 9.19933 16.7076 9.29231L26.7076 19.2923C26.8005 19.3852 26.8743 19.4955 26.9246 19.6169C26.975 19.7383 27.0009 19.8684 27.0009 19.9998C27.0009 20.1312 26.975 20.2614 26.9246 20.3828C26.8743 20.5041 26.8005 20.6144 26.7076 20.7073Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.bee4c3c9a0a2f9a9161311dd32b78561.svg";
export { ForwardRef as ReactComponent };